exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fake-input input:hover {\n  cursor: pointer;\n}\n\n.fake-input input {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\n.fake-input input:focus {\n  outline: none;\n}\n\n.separator-text {\n  color: #00ab98;\n}", ""]);

// exports
